"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNonMusicalWork = exports.isWorkPublicDomain = void 0;
const work_flag_1 = require("@App/enum/work-flag");
const isWorkPublicDomain = (workItem) => { var _a; return (_a = workItem.flags) === null || _a === void 0 ? void 0 : _a.includes(work_flag_1.WorkFlag.PUBLIC_DOMAIN); };
exports.isWorkPublicDomain = isWorkPublicDomain;
const isNonMusicalWork = (workItem) => { var _a; return (_a = workItem.flags) === null || _a === void 0 ? void 0 : _a.includes(work_flag_1.WorkFlag.NON_MUSICAL); };
exports.isNonMusicalWork = isNonMusicalWork;
